"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgCube02 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M11 2.262a.5.5 0 0 0-.743-.437L3.686 5.481a.5.5 0 0 0 0 .874l6.571 3.65A.5.5 0 0 0 11 9.568V2.262ZM2.743 8.119A.5.5 0 0 0 2 8.556l.003 7.122a.5.5 0 0 0 .743.437l6.408-3.56a.5.5 0 0 0 0-.874l-6.41-3.562ZM3.893 17.766a.5.5 0 0 0 0 .874l6.364 3.536a.5.5 0 0 0 .743-.437v-7.072a.5.5 0 0 0-.743-.437l-6.364 3.536ZM13 21.739a.5.5 0 0 0 .743.437l6.365-3.536a.5.5 0 0 0 0-.874l-6.365-3.536a.5.5 0 0 0-.743.437v7.072ZM21.254 16.115a.5.5 0 0 0 .743-.437L22 8.556a.5.5 0 0 0-.743-.437l-6.411 3.562a.5.5 0 0 0 0 .874l6.408 3.56ZM20.314 6.355a.5.5 0 0 0 0-.874l-6.57-3.656a.5.5 0 0 0-.744.437v7.306a.5.5 0 0 0 .743.437l6.57-3.65Z", fill: "currentColor" }) }))); };
exports.default = SvgCube02;
